
/// <reference path="../../meevoStore.module.ts" />
module Meevo.Plugins.MeevoStore {

    class ModalTermsController {

        static $inject = [
            "$sce",
            "$filter",
            "$mdDialog",
            "$translate",
            'modalTitle',
            'modalText'
        ];

        constructor(
            protected $sce: angular.ISCEService,
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public modalTitle: string,
            public modalText: any) {

            this.modalText = $sce.trustAsHtml(this.modalText);
        }

        apply = () => {
            this.$mdDialog.hide({ status: true });
        };

        cancel = () => {
            this.$mdDialog.hide({ status: false });
        };
    }

    angular.module("meevo.plugins.meevoStore")
        .controller("meevo.plugins.meevoStore.ModalTermsController", ModalTermsController);
}